import { Parser as PlaylistParser } from 'm3u8-parser';

export const getPlaylists = (masterFile: string): string[] => {
  const parser = new PlaylistParser();
  parser.push(masterFile);
  parser.end();
  return (parser.manifest.playlists || []).map(entry => entry.uri);
};

export const getStreamFilePaths = (playlistFile: string): string[] => {
  const parser = new PlaylistParser();
  parser.push(playlistFile);
  parser.end();
  const segments = parser.manifest.segments || [];
  return segments.map(segment => segment.uri);
};
